import { useMutation } from 'react-query';

import { PAYMENTS_BACKEND_URL } from '@/config';
import axios from '@/lib/axios';
import { queryClient } from '@/lib/react-query';

export const createInvoicePending = (): Promise<boolean> => {
  const endPoint = PAYMENTS_BACKEND_URL + 'invoice-pending';
  return axios
    .post(
      endPoint,
      {},
      {
        validateStatus: (status) => status < 500,
      }
    )
    .then((response: any) => {
      if (typeof response === 'string') {
        throw Error(`Critical error fetching data in ${endPoint}`);
      }

      return response;
    })
    .catch((error) => {
      throw Error(`Critical error fetching data in ${endPoint}: ${error}`);
    });
};

export const useCreateInvoicePending = () => {
  return useMutation({
    onMutate: async () => {
      await queryClient.cancelQueries(['invoice-pending']);

      const previousDetails = queryClient.getQueryData<boolean>(['invoice-pending']);

      queryClient.setQueryData(['invoice-pending'], {});

      return { previousDetails: previousDetails };
    },
    onError: (_, __, context: any) => {
      if (context?.previousDetails) {
        queryClient.setQueryData(
          ['invoice-pending', context.previousDetails],
          context.previousDetails
        );
      }
    },
    onSuccess: (data) => {
      queryClient.refetchQueries(['invoice-pending', data]);
    },

    mutationFn: createInvoicePending,
  });
};
